import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, LogOut, LayoutDashboard, Shield } from "lucide-react";

export default function Navbar({ variant = "default" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 glass" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-2 group"
        >
          <div className="w-9 h-9 rounded-full bg-[#FF007F] flex items-center justify-center glow-pink">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="font-display font-black text-lg tracking-tighter">
            FESTA<span className="text-[#FF007F]">GRAM</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link
            to="/vitrine-vip"
            data-testid="nav-vitrine"
            className="text-white/70 hover:text-[#00F0FF] transition-colors"
          >
            Eventos ao vivo
          </Link>
          <Link
            to="/vip-apply"
            data-testid="nav-vip-apply"
            className="text-white/70 hover:text-[#00F0FF] transition-colors"
          >
            Quero ser VIP
          </Link>
          <a
            href="/#como-funciona"
            className="text-white/70 hover:text-[#00F0FF] transition-colors"
          >
            Como funciona
          </a>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link
                  to="/admin"
                  data-testid="nav-admin"
                  className="btn-cyan text-sm px-4 py-2"
                >
                  <Shield className="w-4 h-4" /> Admin
                </Link>
              )}
              {(user.role === "organizer" || user.role === "vip") && (
                <Link
                  to="/dashboard"
                  data-testid="nav-dashboard"
                  className="btn-cyan text-sm px-4 py-2"
                >
                  <LayoutDashboard className="w-4 h-4" /> Painel
                </Link>
              )}
              <button
                data-testid="nav-logout"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="p-2 rounded-full hover:bg-white/10 transition-colors"
                title="Sair"
              >
                <LogOut className="w-5 h-5 text-white/70" />
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login"
                className="text-sm text-white/70 hover:text-white transition-colors px-3 py-2"
              >
                Entrar
              </Link>
              <Link to="/register" data-testid="nav-register" className="btn-neon text-sm px-5 py-2">
                Criar conta
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
